import { render, staticRenderFns } from "./HeaderMenuTrigger.vue?vue&type=template&id=7654e421&"
import script from "./HeaderMenuTrigger.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports